import { IRoute } from "./models/types";

import Public from "./layouts/public";
import Login from "./components/auth/login";
import Protected from "./layouts/protected";
import Dashboard from "./pages/dashboard";
import Request from "./pages/Request";
import Inquiry from "./pages/Inquiry";
import TenantNotFound from "./pages/tenant-not-found";
import PasswordChangeRequired from "./pages/password-change-required";
import ScanInventory from "./pages/ScanInventory";
import Activities from "./pages/activity";
import Ordering from "./pages/Ordering";
import LogActivity from "./pages/LogActivity";
import Actuators from "./pages/Actuators";
import AssetAssignment from "./pages/AssetAssignment";
import ModifyAsset from "./pages/ModifyAsset";

const routes: IRoute[] = [
    {
        path: '/',
        as: Public,
        component: Login,
        protected: false
    },
    {
        path: '/login',
        as: Public,
        component: Login,
        protected: false
    },
    {
        path: '/tenant-not-found',
        as: Public,
        component: TenantNotFound,
        protected: false
    },
    {
        path: '/password-change-required',
        as: Public,
        component: PasswordChangeRequired,
        protected: false
    },
    {
        path: '/dashboard',
        as: Protected,
        component: Dashboard,
        protected: true
    },
    {
        path: '/request',
        as: Protected,
        component: Request,
        protected: true
    },
    {
        path: '/inquiry',
        as: Protected,
        component: Inquiry,
        protected: true
    },
    {
        path: '/activity',
        as: Protected,
        component: Activities,
        protected: true
    },
    {
        path: '/log-activity',
        as: Protected,
        component: LogActivity,
        protected: true
    },
    {
        path: '/scan_inventory',
        as: Protected,
        component: ScanInventory,
        protected: true
    },
    {
        path: '/order',
        as: Protected,
        component: Ordering,
        protected: true
    },
    {
        path: '/handle-actuators',
        as: Protected,
        component: Actuators,
        protected: true
    },
    {
        path: '/assign',
        as: Protected,
        component: AssetAssignment,
        protected: true
    },
    {
        path: '/return',
        as: Protected,
        component: AssetAssignment,
        protected: true
    },
    {
        path: '/modify',
        as: Protected,
        component: ModifyAsset,
        protected: true
    }
];

export default routes;
